export interface MenuItem {
  id: number;
  title: string;
  icon: string;
  description: string;
  headLine: string;
  video: string;
  progress: number;
  isAvailable: boolean;
  availableOn: Date | null;
  type: string;
  hasOnDemandCase: boolean;
};

export enum SurveyType {
  Who5 = 'who5',
  Body = 'body',
  Comment = 'comment',
  Custom = 'other'
}
